export const PERSONAL_ACCESS_TOKENS_REQUEST = 'PERSONAL_ACCESS_TOKENS_REQUEST';
export const PERSONAL_ACCESS_TOKENS_SUCCESS = 'PERSONAL_ACCESS_TOKENS_SUCCESS';
export const PERSONAL_ACCESS_TOKENS_FAILURE = 'PERSONAL_ACCESS_TOKENS_FAILURE';
export const PERSONAL_ACCESS_TOKEN_FORM_SUBMITTED =
  'PERSONAL_ACCESS_TOKEN_FORM_SUBMITTED';
export const PERSONAL_ACCESS_TOKEN_CLEAR = 'PERSONAL_ACCESS_TOKEN_CLEAR';
export const MODAL_ID = 'personal-access-tokens-form-modal';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/users/PersonalAccessTokens/PersonalAccessTokensConstants.js